export default "/assets/images/vendor/leaflet-extra-markers/dist/markers_default@2x.png?9593b3c72f31a3f4b40304a0f3cd773c";